/* eslint-disable @typescript-eslint/no-empty-object-type */
import { finalize, map, takeUntil, timer as observableTimer } from 'rxjs';
import { Component, Optional, Inject } from '@angular/core';
import { MatLegacyDialogRef, MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Store } from '@ngrx/store';
import * as authActions from '../auth.actions';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/legacy-dialog";
import * as i2 from "@ngrx/store";
import * as i3 from "@angular/common";
import * as i4 from "@angular/material/legacy-button";
import * as i5 from "../../minutes-seconds.pipe";
function AutoLogoutComponent_h3_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.data.title);
} }
function AutoLogoutComponent_p_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 7);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r0.data.message, i0.ɵɵsanitizeHtml);
} }
const ConfirmationDialogDefault = {
    title: 'Confirmation',
    message: 'Session is going to expire, do you want to stay in the current session?',
    timeout: 1000 * 60 * 5, // 5 minutes
    yesButtonLabel: 'Yes',
    noButtonLabel: 'No'
};
export class AutoLogoutComponent {
    constructor(dialogRef, data = ConfirmationDialogDefault, store) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.store = store;
        this.data = { ...ConfirmationDialogDefault, ...data };
        this.timerStopped = false;
        const interval = 1000;
        const duration = this.data.timeout;
        const stream$ = observableTimer(0, interval).pipe(finalize(() => {
            if (!this.timerStopped) {
                this.dialogRef.close();
            }
        }), takeUntil(observableTimer(duration + interval)), map(value => duration - value * interval));
        this.countdown$ = stream$.pipe(map(value => value / 1000));
    }
    onClick(btnName) {
        if (btnName === 'yes') {
            this.store.dispatch(new authActions.ExtendLogoutTimer());
        }
        else {
            this.store.dispatch(new authActions.Logout());
        }
        this.timerStopped = true;
        this.dialogRef.close();
    }
    static { this.ɵfac = function AutoLogoutComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AutoLogoutComponent)(i0.ɵɵdirectiveInject(i1.MatLegacyDialogRef), i0.ɵɵdirectiveInject(MAT_LEGACY_DIALOG_DATA, 8), i0.ɵɵdirectiveInject(i2.Store)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AutoLogoutComponent, selectors: [["app-auto-logout-confirmation-dialog"]], standalone: false, decls: 21, vars: 10, consts: [["mat-dialog-title", "", 4, "ngIf"], ["mat-dialog-content", ""], [3, "innerHTML", 4, "ngIf"], ["mat-dialog-actions", ""], ["mat-raised-button", "", 3, "click"], ["mat-raised-button", "", "cdkFocusInitial", "", 3, "click", "mat-dialog-close"], ["mat-dialog-title", ""], [3, "innerHTML"]], template: function AutoLogoutComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, AutoLogoutComponent_h3_0_Template, 2, 1, "h3", 0);
            i0.ɵɵtext(1, "\n");
            i0.ɵɵelementStart(2, "div", 1);
            i0.ɵɵtext(3, "\n  ");
            i0.ɵɵtemplate(4, AutoLogoutComponent_p_4_Template, 1, 1, "p", 2);
            i0.ɵɵtext(5, "\n  ");
            i0.ɵɵelementStart(6, "label");
            i0.ɵɵtext(7, "Time Remaining: ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(8);
            i0.ɵɵpipe(9, "async");
            i0.ɵɵpipe(10, "minutesSeconds");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(11, "\n");
            i0.ɵɵelementStart(12, "div", 3);
            i0.ɵɵtext(13, "\n  ");
            i0.ɵɵelementStart(14, "button", 4);
            i0.ɵɵlistener("click", function AutoLogoutComponent_Template_button_click_14_listener() { return ctx.onClick("no"); });
            i0.ɵɵtext(15);
            i0.ɵɵelementEnd();
            i0.ɵɵtext(16, "\n  ");
            i0.ɵɵelementStart(17, "button", 5);
            i0.ɵɵlistener("click", function AutoLogoutComponent_Template_button_click_17_listener() { return ctx.onClick("yes"); });
            i0.ɵɵtext(18);
            i0.ɵɵelementEnd();
            i0.ɵɵtext(19, "\n");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(20, "\n");
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.data.title);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.data.message);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 8, i0.ɵɵpipeBind1(9, 6, ctx.countdown$)), "\n");
            i0.ɵɵadvance(7);
            i0.ɵɵtextInterpolate(ctx.data.noButtonLabel);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("mat-dialog-close", true);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.data.yesButtonLabel);
        } }, dependencies: [i3.NgIf, i1.MatLegacyDialogClose, i1.MatLegacyDialogTitle, i1.MatLegacyDialogContent, i1.MatLegacyDialogActions, i4.MatLegacyButton, i3.AsyncPipe, i5.MinutesSecondsPipe], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(AutoLogoutComponent, { className: "AutoLogoutComponent", filePath: "libs/web/angular/shared/util/auth/src/lib/auth/auto-logout-confirmation/auto-logout.component.ts", lineNumber: 32 }); })();
//# sourceMappingURL=auto-logout.component.js.map